/**
 * Shared CSV download helper for portal report endpoints.
 * Uses fetch so we can attach X-API-Key + X-Atlas-Ingest-Secret headers,
 * then saves the response as a blob.
 */
import { getStoredKey, getIngestSecret, ATLAS_BASE } from "@/lib/atlas-api";

export async function downloadCsv({ path, filename, needsIngest = false, params = {} }) {
  const key = getStoredKey();
  if (!key) throw new Error("Not signed in");
  const qs = new URLSearchParams(
    Object.fromEntries(Object.entries(params).filter(([_, v]) => v !== "" && v != null))
  ).toString();
  const url = `${ATLAS_BASE}${path}${qs ? `?${qs}` : ""}`;
  const headers = { "X-API-Key": key };
  if (needsIngest) headers["X-Atlas-Ingest-Secret"] = await getIngestSecret();
  const res = await fetch(url, { headers });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.detail || `Download failed (HTTP ${res.status})`);
  }
  const blob = await res.blob();
  const objUrl = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = objUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(objUrl);
}
